import axios from "axios";
import { Map, Popup } from "mapbox-gl";
import React, { useContext, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { showErrorMessage } from "../../../helper/helper";
import { UpdatePriceMap } from "../../../helper/mapDataFeed";
import { updatePopup } from "../../../models/MapBoxDataModel";
import { MillPriceOnMap, toPriceFeatureCollection } from "../../../models/price/MillPriceOnMap";
import { MarketContext, OrganisationWithPermission } from "../MyPrices";

type Props = {
    map: Map
    orgsParam: OrganisationWithPermission[]
    updateData: number | undefined
}

export function MapMillPrice({ map, orgsParam, updateData }: Props) {

    const popup = useRef<Popup | undefined>(undefined)

    const priceSelected = useContext(MarketContext)

    const publicPrices = useRef<any>(undefined)

    const token = useSelector((state: any) => state.token.value)


    useEffect(() => {
        refetchData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateData])

    function getMatchedObjects(geoJsonData: any, orgs: OrganisationWithPermission[]): any[] {
        const matchedObjects: any[] = [];

        if (!geoJsonData || !geoJsonData.features) {
            return matchedObjects; // Return empty array if geoJsonData is invalid
        }

        orgs.forEach((org: OrganisationWithPermission) => {
            const orgId = org.organisation.id;

            const p = geoJsonData.features.find(f => f.properties.mill_id === orgId)
            if (p) {
                const matchedObject = {
                    ...p,
                    ...org
                };
                matchedObjects.push(matchedObject);
            }
        })
        return matchedObjects;
    }

    async function refetchData() {
        try {
            const pricesCall = await axios.get(`${process.env.REACT_APP_BASE_URL_PUBLIC}/mapTilingService/prices?token=${token}`, {
                withCredentials: false,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            })
            const geoJson = toPriceFeatureCollection(MillPriceOnMap.buildAll(pricesCall.data?.prices))
            publicPrices.current = geoJson
            const matches = getMatchedObjects(geoJson, orgsParam)
            if (matches.length === 1) {
                priceSelected.setPriceSelected(matches[0].properties)
            } else {
                updateMap()
            }
        } catch (error) {
            showErrorMessage(error)
        }
    }

    const isMyMill = (id: number) => {
        return orgsParam?.some(p => p.organisation.id === id) ?? false
    }

    useEffect(() => {
        updateMap()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [priceSelected.priceSelected])

    function updateMap() {
        UpdatePriceMap(map, publicPrices.current, isMyMill, priceSelected.priceSelected,
            (f: any) => {
                const price = publicPrices.current?.features?.find(g => g.properties.id === f.id)
                if (price.properties.mill_id === priceSelected?.priceSelected?.mill_id) {
                    priceSelected.setPriceSelected(undefined)
                } else {
                    priceSelected.setPriceSelected(price.properties)
                }
            },
            (f: any, geometry: any) => {
                updatePopup(map, publicPrices.current?.features?.find(p => p.properties.id === f.properties.id), priceSelected.priceSelected, popup)
            }, () => {
                popup.current?.remove()
            }
        )
    }


    // useEffect(() => {
    //     const changeLanguageHandler = (l) => {
    //         if (map) {
    //             updatePopup(map, prices, popups.current)
    //         }
    //     };

    //     i18n.on('languageChanged', changeLanguageHandler);

    //     return () => {
    //         i18n.off('languageChanged', changeLanguageHandler);
    //     };
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [i18n])

    // const getOrgForId = (id: number): Organisation => {
    //     return prices.find(p => p.org.id === id).org
    // }

    return (
        <>

        </>
    )
}